import { render, staticRenderFns } from "./InputCheckTerms.vue?vue&type=template&id=51de2d80&scoped=true"
import script from "./InputCheckTerms.vue?vue&type=script&lang=js"
export * from "./InputCheckTerms.vue?vue&type=script&lang=js"
import style0 from "./InputCheckTerms.vue?vue&type=style&index=0&id=51de2d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51de2d80",
  null
  
)

export default component.exports